import { IMG } from "../../data/site";
import { Reveal, Label } from "./Reveal";
import { motion } from "framer-motion";
import { Store, Award, MapPin, Bike } from "lucide-react";

const MILESTONES = [
  { year: "2002", title: "Kurnool Sub Dealer", body: "The Sasya journey begins — our first Hero two-wheeler sub-dealership opens in Kurnool.", icon: Bike },
  { year: "2007", title: "Kurnool Main Dealer", body: "Earning customers' trust, we're promoted to a full Hero main dealership for Kurnool.", icon: Award },
  { year: "2018", title: "Kurnool Extension Showroom", body: "Growing demand leads us to open our first extension showroom in Kurnool.", icon: Store },
  { year: "2021", title: "Kodumur Extension Showroom", body: "We expand beyond Kurnool with a brand-new extension showroom in Kodumur.", icon: MapPin },
];

export const Legacy = () => (
  <section id="legacy" className="relative py-24 md:py-32 bg-[#0d0d0d] border-y border-white/10">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-end">
        <Reveal className="md:col-span-7">
          <Label>The Sasya Story</Label>
          <h2 className="mt-4 font-heading text-4xl sm:text-6xl font-bold uppercase tracking-tighter text-white leading-[0.9]">
            Two decades of<br /><span className="text-red-600">two-wheeler</span> trust
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-5">
          <p className="text-zinc-400 md:text-lg">
            From a single sub-dealership in 2002 to a family of showrooms across Kurnool & Kodumur — every
            milestone driven by the same promise: the right ride, the right price, and service you can rely on for life.
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-8">
        {/* image */}
        <Reveal className="md:col-span-5">
          <div className="relative h-64 md:h-full md:min-h-[440px] overflow-hidden border border-white/10 group">
            <img src={IMG.showroom} alt="Sasya Hero showroom" className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 p-6">
              <div className="font-heading text-6xl font-bold text-white/90">2002</div>
              <div className="text-xs uppercase tracking-[0.3em] text-red-500">Where it all began</div>
            </div>
          </div>
        </Reveal>

        {/* timeline */}
        <div className="md:col-span-7">
          <div className="relative pl-10">
            <div className="absolute left-[15px] top-2 bottom-2 w-px bg-white/10" />
            {MILESTONES.map((m, i) => (
              <Reveal key={m.year} delay={i * 0.1}>
                <div className="relative pb-8 last:pb-0">
                  <motion.span
                    className="absolute -left-10 top-1 flex items-center justify-center w-8 h-8 rounded-full bg-red-600 ring-4 ring-[#0d0d0d]"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ type: "spring", stiffness: 260, damping: 18, delay: i * 0.1 }}
                  >
                    <m.icon size={15} className="text-white" />
                  </motion.span>
                  <div className="border border-white/10 bg-[#111] p-5 md:p-6 hover:border-red-600/50 transition-colors">
                    <div className="flex items-center gap-3">
                      <span className="font-heading text-2xl md:text-3xl font-bold text-red-600">{m.year}</span>
                      <span className="h-px flex-1 bg-white/10" />
                    </div>
                    <h3 className="mt-2 font-heading text-lg md:text-xl font-semibold uppercase text-white">{m.title}</h3>
                    <p className="mt-1.5 text-zinc-400 text-sm">{m.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
